<template>
  <MasterLayout brand-url="https://www.hrsa.gov/foia">
    <template #navbar>
      <BrandLinks :links="[
        ['https://www.hrsa.gov/about/organization/bureaus/index.html', 'Bureaus and Offices'],
        ['https://www.hrsa.gov/about/news/index.html', 'Newsroom'],
        ['https://www.hrsa.gov/a-z/index.html', 'A-Z Index'],
        ['https://www.hrsa.gov/about/contact/index.html', 'Contact HRSA']
      ]"/>
    </template>

    <template #footer>
      <SiteFooter />
    </template>

    <template #post-footer>
      <StandardGovLinks class="pt-4 pb-2" />
      <hr />
      <LanguageAssistance class="pt-2 pb-4" />
    </template>
  </MasterLayout>
</template>

<script>
import MasterLayout from '@/components/MasterLayout';
import BrandLinks from '@/components/BrandLinks';
import LanguageAssistance from './components/LanguageAssistance';
import SiteFooter from './components/SiteFooter';
import StandardGovLinks from './components/StandardGovLinks';

export default {
  components: {
    BrandLinks, LanguageAssistance, MasterLayout, SiteFooter, StandardGovLinks
  }
};
</script>
